import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { EditMode } from './type';

type StandardApplicationModuleFooterProps = {
    editMode?: EditMode;
    setEditMode: (value: EditMode) => void;
};

const StandardApplicationModuleFooter = ({ editMode, setEditMode }: StandardApplicationModuleFooterProps) => {
    const { t } = useTranslation(['standardApplicationModuleDetails']);
    switch (editMode) {
        case EditMode.ModuleDetails:
            return (
                <>
                    <Button onClick={() => setEditMode(null)} type="default">
                        {t('standardApplicationModuleDetails:actions.cancel')}
                    </Button>
                    <Button form="updateMainDetails" htmlType="submit" type="primary">
                        {t('standardApplicationModuleDetails:actions.update')}
                    </Button>
                </>
            );
        default:
            return null;
    }
};

export default StandardApplicationModuleFooter;
